import BaseComponent from '../../../js/base-component';

class CareProductsStepOne extends BaseComponent {
    constructor(element) {
        super(element);

        this.element.querySelector('.u-button.is--care').addEventListener("click", () => {
            if (!this.element.checkValidity()) {
                this.element.classList.add('invalid');
            }
        });
    }

    onInit() {}
}

export default {
    name: 'CareProductsStepOne',
    definition: CareProductsStepOne
};